<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <fuse-sidebar class="sidebar" name="voucher-template-main-sidebar" position="left" lockedOpen="gt-md">
        <voucher-template-main-sidebar></voucher-template-main-sidebar>
    </fuse-sidebar>

    <div class="center">

        <div class="content-card" style="overflow-y: scroll;">
            <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
                <mat-tab-group fxLayout="column" fxFlex>
                    <mat-tab label="{{'Basic data'|translate}}">
                        <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
                              fxFlex="1 0 auto" name="form" [formGroup]="form" (ngSubmit)="onSubmit()">

                            <div class="h2 mb-24">{{'Template group data'|translate}}</div>

                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                                    <mat-label>{{'Name'|translate}}</mat-label>
                                    <input matInput formControlName="name" required>
                                    <mat-error>{{'Name is required!'|translate}}</mat-error>
                                </mat-form-field>
                            </div>

                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                                    <mat-label>{{'Color'|translate}}</mat-label>
                                    <input matInput formControlName="color" type="color" required>
                                    <mat-hint>{{'Click and set the color.'|translate}}</mat-hint>
                                    <mat-error>{{'Color is required!'|translate}}</mat-error>
                                </mat-form-field>
                            </div>

                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                <mat-form-field appearance="outline" fxFlex="100">
                                    <mat-label>{{'Description'|translate}}</mat-label>
                                    <textarea matInput formControlName="description"></textarea>
                                </mat-form-field>
                            </div>

                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                <button type="button" mat-raised-button (click)="fileInput.click()">Wybierz plik ikony</button>
                                <input hidden formControlName="iconFile" (change)="onFileSelected($event)" #fileInput type="file">
                                <span class="file-name">{{selectedFile?.name}}</span>
                            </div>


                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                <div fxLayout="row" fxLayoutAlign="center center">
                                    <button mat-raised-button type="submit" color="accent" [disabled]="processing">
                                        <span *ngIf="!processing">{{'Save'|translate}}</span>
                                        <span *ngIf="processing">{{'Saving'|translate}}...</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </mat-tab>
                    <mat-tab label="{{'Images'|translate}}" *ngIf="gallery">
                        <div class="order-details tab-content p-24" fusePerfectScrollbar>

                            <div class="content-card" style="overflow-y: scroll;">
                                <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
                                    <div class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column"
                                         fxLayoutAlign="start"
                                         fxFlex="1 0 auto">

                                        <div class="col-sm-12">
                                            <div class="container" appDnd (fileDropped)="onFileDropped($event)">
                                                <input type="file" #fileDropRef id="fileDropRef" multiple (change)="fileBrowseHandler($event.target.files)" />
                                                <mat-icon class="nav-link-icon">cloud_upload</mat-icon>
                                                <h3>{{'Drag and drop file here'|translate}}</h3>
                                                <h3>{{'or'|translate}}</h3>
                                                <label for="fileDropRef">{{'Browse for file'|translate}}</label>
                                            </div>
                                        </div>

                                        <table>
                                            <tr>
                                                <td>
                                                    <div fxLayout="row" class="files-list">
                                                        <div class="single-file" *ngFor="let file of files; let i = index">
                                                            <!--        <img src="assets/img/dnd/ic-file.svg" width="45px" alt="file">-->
                                                            <div class="info">
                                                                <h4 class="name">
                                                                    {{ file?.name }}
                                                                </h4>
                                                                <p class="size">
                                                                    {{ formatBytes(file?.size) }}
                                                                </p>
                                                                <app-progress [progress]="file?.progress"></app-progress>
                                                            </div>
                                                            <!--        <img src="assets/img/dnd/ic-delete-file.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i)">-->
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="cards" fxLayout="row wrap">
                                                        <div class="card" *ngFor="let image of this.gallery.items" fxFlex="20">
                                                            <div class="card-preview" fxFlex="100">
                                                                <div class="fuse-card" fxFlex="100" (click)="showGalleryItemDialog(image)">
                                                                    <img src="data:image/png;base64,{{image.image}}" style="max-width: 150px;"/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </div>
</div>
